// eslint-disable-next-line
import project2017fall from '!json-loader!yaml-loader!./2017fall.yaml'
// eslint-disable-next-line
import project2018fall from '!json-loader!yaml-loader!./2018fall.yaml'
// eslint-disable-next-line
import project2019fall from '!json-loader!yaml-loader!./2019fall.yaml'
const projects = [
    project2019fall,
    project2018fall,
    project2017fall,
]

export default projects



// WEBPACK FOOTER //
// ./src/projects/index.js